import { Card, Grid, Skeleton, Box } from "@mui/material";

export default function BasicInfoSkeleton() {
  return (
    <Card sx={{ p: 3, borderRadius: 2 }}>
      <Skeleton width={280} height={20} />

      <Grid container spacing={2} mt={1}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Skeleton variant="rectangular" height={200} />
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Skeleton height={48} />
          <Skeleton height={48} sx={{ mt: 2 }} />
          <Skeleton height={48} sx={{ mt: 2 }} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Skeleton height={48} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Skeleton height={80} />
        </Grid>

        <Box
          display="flex"
          justifyContent="center"
          width="100%"
          gap={2}
          mt={2}
        >
          <Skeleton width={120} height={40} />
          <Skeleton width={120} height={40} />
        </Box>
      </Grid>
    </Card>
  );
}
